import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import store from "@/store";
import ListChats from "./components/ListChats/ListChats.vue";
import SingleChat from "./components/SingleChat/SingleChat.vue";
import { ChatComunication } from "../ChatWindow/Model/ChatComunication.model";
import { LOCAL_CHAT_ACTIONS } from "./constants/LocalChatWindow.constants";
import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";

@Component({
  name: "Chat",
  computed: {
    ...mapGetters({
      chatAction: "getChatComunication"
    })
  },
  components: {
    ListChats,
    SingleChat
  }
})
export default class Chat extends Vue {
  chatAction!: ChatComunication;
  chat!: Chat | null;
  showList = true;
  showWindow = false;
  ACTIONS = LOCAL_CHAT_ACTIONS;

  goToChat(chat: Chat) {
    this.chat = chat;
    this.showList = false;
  }

  closeChat() {
    this.chat = null;
    this.showList = true;
  }

  closeChatWindow() {
    this.showWindow = false;
    const action: ChatComunication = {
      action: this.ACTIONS.CLOSE_CHAT
    };

    store.commit(STORE_CONSTANTS.CHAT_ACTION, action);
  }

  @Watch("chatAction")
  handleChatAction() {
    const action = this.chatAction.action;
    if (action == "" || action == this.ACTIONS.CLOSE_CHAT) {
      return;
    }

    switch (action) {
      case this.ACTIONS.OPEN_CHAT: {
        this.showWindow = true;
        break;
      }
    }
    //this.disengageAction();
  }
  disengageAction() {
    store.commit(STORE_CONSTANTS.CHAT_ACTION, {
      action: ""
    });
  }
}
